import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';
import { MobilecrashreportService } from 'api/mobilecrashreport/mobilecrashreport.service';
declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'mobilecrashreport-page',
    templateUrl: './mobilecrashreport.html'
})
export class MobileCrashreport implements OnInit {
    progressPer :string = "0%";
    crashList = []
    message: any
    constructor(private MobilecrashreportService: MobilecrashreportService, private router: Router) {
    }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'ADMIN' || localStorage.getItem('type') == 'DEVELOPER' || localStorage.getItem('type') == 'SUPERCLIENT' || localStorage.getItem('type') == 'CLIENT')) {
            $(function () {
            })
            this.initData();
        } else {
            this.router.navigate(['/']);
        }
    }
    initData() {
        this.progressPer = "50%";
        this.MobilecrashreportService.allMobilecrashreport().then(data => {
            if (data.status) {
                this.crashList = data.data
                if (data.data.length == 0) {
                    $.notify({
                        message: "Great, Your Code Work Perfect.No Crash Report Found"
                    },
                        {
                            type: 'success',
                            placement: {
                                from: 'bottom',
                                align: 'left'
                            },
                            delay: 100,
                            timer: 100
                        });
                }
            }
            this.progressPer = "100%";
            this.progressTimeOut();
        })
    }
    progressTimeOut()
    {
      setTimeout(()=>
      { 
        this.progressPer = "0%"; 
      },200);
    }
    copyFile(val) {
        var v = JSON.stringify(val);
        let selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = v;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }
    Showdetails(crashes) {
        this.message = crashes.message
    }
    deleteSure() {
        this.MobilecrashreportService.deleteMobilecrashreport().then(data => {
            if (data.status) {
                this.crashList = []
                $.notify({
                    message: data.message
                }, {
                    type: 'success',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 100
                });
                $(function () {
                    $('#deleteSureModal').modal('toggle');
                });
            } else {
                $.notify({
                    message: data.message
                }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 100
                });
            }
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/mobilecrashreport/mobilecrashreport.page.ts